import { ReactElement } from 'react';
import { Field } from 'formik';

import { Label } from '../Label/Label';
import { Select, OptionProps } from '../Select/Select';
import { validateField } from '../../utils/validations';
import { getDataTest } from '../../utils/dataTests';

export interface SelectFieldProps {
    name: string;
    options: OptionProps[];
    label?: string | [string, string];
    className?: string;
    placeholder?: string;
    max?: number;
    error?: string;
    optional?: boolean;
    onHelpClick?: () => void;
    allowFieldValidation?: boolean;
}

export const SelectField = ({
    name,
    options,
    label,
    className,
    placeholder,
    max,
    error,
    optional,
    onHelpClick,
    allowFieldValidation,
    ...props
}: SelectFieldProps): ReactElement => {
    const renderLabel = (label: string | [string, string], id: string) => {
        if (Array.isArray(label)) {
            return (
                <Label htmlFor={id} description={label[1]} data-test={getDataTest(props, 'Label')}>
                    {label[0]}
                </Label>
            );
        } else {
            return (
                <Label htmlFor={id} onHelpClick={onHelpClick} data-test={getDataTest(props, 'Label')}>
                    {label}
                </Label>
            );
        }
    };

    return (
        <div>
            {label && renderLabel(label, name)}
            <Field
                name={name}
                id={name}
                component={Select}
                className={className}
                options={options}
                placeholder={placeholder}
                error={!!error}
                validate={(value: string | number) =>
                    (allowFieldValidation ?? true) && validateField(value, optional, undefined, max, 'select')
                }
                data-test={getDataTest(props)}
            />
        </div>
    );
};
